<!-- layers -->
<div
  class="w-full tw-grid tw-grid-cols-4 gap-3 tw-bg-white dark:tw-border-0 dark:tw-bg-dark-500 tw-p-3 tw-rounded-lg tw-border-2 tw-border-[#d8d1c1] tw-max-h-[150px] tw-overflow-y-auto"
>
  <div
    *ngFor="let layer of layers"
    rowspan="1"
    colspan="1"
    (click)="onSelectLayer(layer.layer)"
  >
    <div
      class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-cursor-pointer tw-py-2 tw-rounded-md"
      [class]="
        selectedLayers?.includes(layer.layer)
          ? ' tw-bg-primary-100  dark:tw-bg-dark-100'
          : ' tw-bg-gray-50 dark:tw-bg-dark-300 hover:tw-bg-gray-100 '
      "
    >
      <i
        class="mdi mdi-24px tw-pb-1 ignore-dark-color"
        [placeGridLayerIcon]="layer.icon"
      ></i>
      <div
        class="tw-text-center tw-font-vazirmatn tw-pt-1 max1row dark:tw-text-gray-300"
        [matTooltip]="layer.title"
      >
        {{ layer.title }}
      </div>
    </div>
  </div>
  <div
    class="tw-my-1 tw-col-span-4 tw-cursor-pointer tw-flex tw-justify-end tw-items-center"
  >
    <i
      *ngIf="layerDataOptions?.length"
      class="mdi mdi-24px tw-mx-2 mdi-trash-can-outline"
      (click)="this.onRemoveSelectedLayer()"
      [matTooltip]="'common.removeSelectedItems' | translate"
    ></i>
    <i class="mdi mdi-24px mdi-menu" (click)="this.onFilterToggle()"></i>
  </div>
</div>

<!-- filters -->
<div
  *ngIf="isShowFilters"
  class="w-full tw-bg-white dark:tw-bg-dark-500 tw-mt-2 tw-p-3 tw-rounded-lg dark:tw-border-0 tw-border-2 tw-border-[#d8d1c1] tw-max-h-[275px] tw-overflow-x-hidden tw-overflow-y-auto tw-pr-2 move-bottom"
>
  <div class="row">
    <!-- searchTerm -->
    <div class="md:tw-w-full">
      <form-field
        [(value)]="searchTerm"
        label="common.search"
        [control]="form?.get('searchTerm')"
        [isShowValidationStatusIcon]="false"
      >
      </form-field>
    </div>

    <!-- state -->
    <div class="md:tw-w-1/2">
      <custom-select-search
        [items]="provinces"
        label="common.state"
        [removable]="false"
        [value]="selectedProvince"
        [isShowValidationStatusIcon]="false"
        (valueChange)="onChangeProvince($event)"
      >
      </custom-select-search>
    </div>

    <!-- city -->
    <div class="md:tw-w-1/2">
      <custom-select-search
        [isDisabled]="!selectedProvince"
        [items]="cities"
        [value]="selectedCity"
        [removable]="false"
        [loading]="cityLoading"
        (valueChange)="selectedCity = $event"
        [isShowValidationStatusIcon]="false"
        label="common.city"
      >
      </custom-select-search>
    </div>



    <!-- lat -->
    <div class="md:tw-w-1/2">
      <form-field
        [value]="+lat"
        (valueChange)="lat = $event"
        label="common.lat"
        [control]="form?.get('lat')"
        [isShowValidationStatusIcon]="false"
      >
      </form-field>
    </div>

    <!-- lon -->
    <div class="md:tw-w-1/2">
      <form-field
        [value]="+lon"
        (valueChange)="lon = $event"
        label="common.lon"
        [control]="form?.get('lon')"
        [isShowValidationStatusIcon]="false"
      >
      </form-field>
    </div>

    <div class="md:tw-w-full">
      <div
        (click)="getLayerDataApi()"
        class="btn btn-secondary btn-active-secondary tw-font-vazirmatn tw-text-white tw-w-full"
      >
        {{ "common.search" | translate }}
        <i class="mdi mdi-24px mdi-magnify"></i>
      </div>
    </div>
  </div>
</div>

<!-- selection list  -->
<div
  *ngIf="layerDataOptions?.length"
  class="w-full tw-bg-white dark:tw-bg-dark-500 tw-mt-1 tw-p-1 tw-rounded-lg dark:tw-border-0 tw-border-2 tw-border-[#d8d1c1] tw-max-h-[163px] tw-overflow-hidden tw-pr-2"
>
  <map-places-grid-selection-list
    searchLabel="common.search"
    [items]="layerDataOptions"
    [maxShowItemInDisplay]="1"
    [isFixedSearchBox]="true"
    [isShowSelectAll]="false"
    responsiveClass="tw-w-full"
    searchBoxGridclass="tw-w-full"
    listOptionCustomClass="tw-py-11 !tw-h-[52px]"
    (clickedOption)="onSelectPlace($event)"
  >
  </map-places-grid-selection-list>
</div>
